import axios from "axios";

const api = axios.create({
  baseURL: "https://app-dc37e42a-38d5-480d-9a3d-1349ea33f548.cleverapps.io/api",
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
